import React,{useState} from 'react';
import EcxSurveyEditor from '../../helpers/ecxsurvey/EcxSurveyEditor'
import { useSurveyStore } from '../../helpers/ecxsurvey/surveyutilities/surveyStore';
import { useNavigate } from 'react-router-dom';

const CreateSurveyPage = () => {
    const exportToJSON = useSurveyStore((state)=>state.exportToJSON);
    const [surveyJson,setSurveyJson] = useState(null);
    const navigate = useNavigate();
    const handleSave = () => {
        console.log("✅ Save clicked — handleSave from parent");
        // your save logic here
        const surveyJson = exportToJSON();
        //   setSurveyJson(exportToJSON());
        console.log(surveyJson)
    };

    const handlePublish = () => {
        console.log("🚀 Publish clicked — handlePublish from parent");
        // your publish logic here

        navigate('/surveys/survey-publish');


    };
    return (
        <div>
            <EcxSurveyEditor
                templateType={'survey'}
                onSave={handleSave}
                onPublish={handlePublish}  />
        </div>
    );
};

export default CreateSurveyPage;